import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36f26117"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "DialogSection",
  style: {"flex-direction":"row"}
}
const _hoisted_6 = {
  key: 1,
  class: "DialogSection",
  style: {"flex-direction":"row"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = {
  key: 2,
  class: "DialogSection",
  style: {"flex-direction":"row"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_10 = ["CookiesInvalidInput"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_12 = { class: "DialogSection" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_14 = { class: "DialogSection" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_17 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesRadioButton = _resolveComponent("CookiesRadioButton")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.DialogData.Type === 'Import')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_CookiesIcon, {
                  class: "SQR2em F2em",
                  ID: ('ItemImport' as IconsIDs)
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'Export')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_CookiesIcon, {
                  class: "SQR2em F2em",
                  ID: ('Export' as IconsIDs)
                })
              ]))
            : _createCommentVNode("", true),
          _hoisted_7,
          (_ctx.DialogData.Type === 'Import')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_CookiesDropInputObject, {
                  Name: _ctx.Translate('Source'),
                  Default: '',
                  Options: _ctx.TransferSources,
                  Selectors: ['Name'],
                  Res: 'D_Transfers_ImportSource'
                }, null, 8, ["Name", "Options"]),
                _createVNode(_component_CookiesIcon, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.EditCategories('TransferSources', 'Sources'))),
                  class: "SQR2em V-Auto HoverGLow Pointer BlackWhite",
                  ToolTip: _ctx.Translate('Add new source'),
                  ID: ('Edited' as IconsIDs)
                }, null, 8, ["ToolTip"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'Export')
            ? (_openBlock(), _createBlock(_component_CookiesNormalInput, {
                key: 3,
                Placeholder: _ctx.Translate('Customer Name'),
                Res: 'D_Transfer_Customer'
              }, null, 8, ["Placeholder"]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'Export')
            ? (_openBlock(), _createBlock(_component_CookiesNormalInput, {
                key: 4,
                Placeholder: _ctx.Translate('Customer Phone'),
                Res: 'D_Transfer_CustomerPhone'
              }, null, 8, ["Placeholder"]))
            : _createCommentVNode("", true),
          _hoisted_9,
          _createElementVNode("div", {
            class: _normalizeClass(["DialogSection P1em", (_ctx.ErrorsVisibilty && (_ctx.MEMRead('D_Transfer_IsPack') === '' || _ctx.MEMRead('D_Transfer_IsPack') === undefined)) ? 'ErrorBorder Rad2': '']),
            CookiesInvalidInput: _ctx.MEMRead('D_Transfer_IsPack') === '' || _ctx.MEMRead('D_Transfer_IsPack') === undefined
          }, [
            _createVNode(_component_CookiesRadioButton, {
              Res: 'D_Transfer_IsPack',
              Value: 1,
              Name: _ctx.Translate('Pack')
            }, null, 8, ["Name"]),
            _createVNode(_component_CookiesRadioButton, {
              Res: 'D_Transfer_IsPack',
              Value: 0,
              Name: _ctx.Translate('Split')
            }, null, 8, ["Name"])
          ], 10, _hoisted_10),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_CookiesDropInputObject, {
              onSelected: _ctx.AddItem,
              Icon: 'ImgUrl',
              RowHeight: '4em',
              Name: _ctx.Translate('Item'),
              Default: '',
              Options: _ctx.Items,
              Selectors: [['Code'], ['Name'], ['AvailableQuantity']],
              Res: 'D_Transfer_Item'
            }, null, 8, ["onSelected", "Name", "Options"]),
            _createVNode(_component_CookiesTable, {
              CookiesInvalidInput: _ctx.TransferItems.length < 1,
              ErrorData: _ctx.ErrorsVisibilty && _ctx.TransferItems.length < 1,
              onDeleteRow: _ctx.RemoveItem,
              class: "Shadow1",
              TableSettings: _ctx.TableSettings,
              CookiesData: _ctx.TransferItems,
              Search: '',
              Loading: (_ctx.Loading.length > 0),
              Saving: (_ctx.SavingTable.length > 0),
              onInputChanged: _ctx.InputChanged,
              Saved: _ctx.Saved
            }, null, 8, ["CookiesInvalidInput", "ErrorData", "onDeleteRow", "TableSettings", "CookiesData", "Loading", "Saving", "onInputChanged", "Saved"])
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Note'),
              Res: 'D_Transfer_Note'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_15
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access('Inventory_Items_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Close')), 1),
            (!_ctx.DialogData.Editing)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
                  style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
                  class: "F-Bold CookiesButton DialogFooterButton"
                }, _toDisplayString(_ctx.DialogData.Editing ? _ctx.Translate('Save') : _ctx.Translate('Add')), 5))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}